import cs from 'classnames';
import React, { useState } from 'react';
import { ReactBootstrapModal } from 'shared/components/ReactModal';
import { useCancelApplicationMutation } from '../generated.graphql';


export interface Props {
  portalSlug: string;
  className?: string;
}


export const CancelApplicationButton = ({ portalSlug, className }: Props) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [result, executeMutation] = useCancelApplicationMutation();

  return (
    <>
      <button className={cs(className ?? 'btn btn-link')} type="button" disabled={result.fetching} onClick={() => { setShowConfirmation(true); }}>Cancel Application</button>
      <ReactBootstrapModal
        title="Cancel Application"
        isOpen={showConfirmation}
        onRequestClose={() => setShowConfirmation(false)}
        className="text-center"
      >
        <p className="mt-4 lead">Are you sure you want to cancel your application?</p>
        <p>Please note the contents of your cart will be removed.</p>
        <button className="btn btn-outline-secondary mr-2 mb-2" disabled={result.fetching} type="button" onClick={() => setShowConfirmation(false)}>Return to application</button>
        <button className="btn btn-primary mr-2 mb-2" 
                disabled={result.fetching} 
                type="button" 
                onClick={async () => {
                  await executeMutation({input: {portalSlug: portalSlug}});
                  setShowConfirmation(false)
                }}
        >
          Confirm
        </button>
      </ReactBootstrapModal>
    </>
  );
}
